import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {StorageService} from '../../services/storage.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BidService} from '../../services/bid.service';

const levenshtein = require('js-levenshtein');

@Component({
  selector: 'app-cedula-profesional',
  templateUrl: './cedula-profesional.page.html',
  styleUrls: ['./cedula-profesional.page.scss'],
})
export class CedulaProfesionalPage implements OnInit {

  cedula: any = {};
  cedulaForm: FormGroup;
  curpD: string;
  documentNumberF: string;
  nombreD: string;
  paternoD: string;
  maternoD: string;
  personId: string;
  operationId;

  constructor(private router: Router, private storageService: StorageService, private fb: FormBuilder, private bidService: BidService) {

    this.storageService.getStorage('operationID').then((op: any) => {

      this.operationId = op.value;
    });
    this.storageService.getStorage('personIdRegister').then((op: any) => {
      if (op.value !== null) {
        console.log('personIdRegister');
        this.personId = op.value;
      } else {
        this.storageService.getStorage('personID').then((p: any) => {
          if (p.value !== null) {
            console.log('personID');
            this.personId = p.value;
          }
        });
      }
    });

    this.storageService.getStorage('OCR').then(data => {

        this.cedula = JSON.parse(data.value);

        console.log(this.cedula);
        try {
          this.curpD = this.cedula.curp;
          if (this.curpD.length === 18) {
            this.cedulaForm.controls['curp'].setValue(
              this.cedula.curp
            );
          }
        } catch (e) {
        }


        try {
          this.nombreD = this.cedula.name;
          if (this.curpD.length > 0) {
            this.cedulaForm.controls['name'].setValue(
              this.cedula.name
            );
          }
        } catch (e) {
        }


        const apellidos = this.cedula.surname.split(' ');
        try {
          try {
            this.paternoD = apellidos[0];
            if (this.paternoD.length > 0) {
              this.cedulaForm.controls['firstSurname'].setValue(
                apellidos[0]
              );
            }
          } catch (e) {
          }

          try {
            this.maternoD = apellidos[1];
            if (this.paternoD.length > 0) {
              this.cedulaForm.controls['secondSurname'].setValue(
                apellidos[1]
              );
            }
          } catch (e) {
          }

        } catch (e) {

          try {
            this.paternoD = this.cedula.surname;
            if (this.paternoD.length > 0) {
              this.cedulaForm.controls['firstSurname'].setValue(
                this.cedula.surname
              );
            }
          } catch (e) {
          }
        }

        this.cedulaForm.controls['nationality'].setValue(
          this.cedula.nationality
        );
        this.cedulaForm.controls['dateOfBirth'].setValue(
          this.cedula.dateOfBirth
        );
        this.cedulaForm.controls['birthplace'].setValue(
          this.cedula.birthplace
        );

        this.cedulaForm.controls['gender'].setValue(
          this.cedula.gender
        );
        this.cedulaForm.controls['expedition_date'].setValue(
          this.cedula.expedition_date
        );

        this.cedulaForm.controls['dateOfExpiry'].setValue(
          this.cedula.dateOfExpiry
        );

        this.documentNumberF = this.cedula.documentNumber;
        this.cedulaForm.controls['documentNumber'].setValue(
          this.cedula.documentNumber
        );


        this.cedulaForm.get('curp').valueChanges.subscribe((event) => {
          this.cedulaForm.get('curp').setValue(event.toUpperCase(), {emitEvent: false});
        });

        this.cedulaForm.get('name').valueChanges.subscribe((event) => {
          this.cedulaForm.get('name').setValue(event.toUpperCase(), {emitEvent: false});
        });

        this.cedulaForm.get('surname').valueChanges.subscribe((event) => {
          this.cedulaForm.get('surname').setValue(event.toUpperCase(), {emitEvent: false});
        });

        this.cedulaForm.get('firstSurname').valueChanges.subscribe((event) => {
          this.cedulaForm.get('firstSurname').setValue(event.toUpperCase(), {emitEvent: false});
        });

        this.cedulaForm.get('secondSurname').valueChanges.subscribe((event) => {
          this.cedulaForm.get('secondSurname').setValue(event.toUpperCase(), {emitEvent: false});
        });

        this.cedulaForm.get('nationality').valueChanges.subscribe((event) => {
          this.cedulaForm.get('nationality').setValue(event.toUpperCase(), {emitEvent: false});
        });

        this.cedulaForm.get('dateOfBirth').valueChanges.subscribe((event) => {
          this.cedulaForm.get('dateOfBirth').setValue(event.toUpperCase(), {emitEvent: false});
        });

        this.cedulaForm.get('birthplace').valueChanges.subscribe((event) => {
          this.cedulaForm.get('birthplace').setValue(event.toUpperCase(), {emitEvent: false});
        });

        this.cedulaForm.get('gender').valueChanges.subscribe((event) => {
          this.cedulaForm.get('gender').setValue(event.toUpperCase(), {emitEvent: false});
        });

        this.cedulaForm.get('expedition_date').valueChanges.subscribe((event) => {
          this.cedulaForm.get('expedition_date').setValue(event.toUpperCase(), {emitEvent: false});
        });

        this.cedulaForm.get('dateOfExpiry').valueChanges.subscribe((event) => {
          this.cedulaForm.get('dateOfExpiry').setValue(event.toUpperCase(), {emitEvent: false});
        });
        this.cedulaForm.get('documentNumber').valueChanges.subscribe((event) => {
          this.cedulaForm.get('documentNumber').setValue(event.toUpperCase(), {emitEvent: false});
        });


        this.storageService.saveToStorage('valuePerson', this.cedula.documentNumber);

      }
    );
  }

  get name() {
    return this.cedulaForm.get('name');
  }

  get firstSurname() {
    return this.cedulaForm.get('firstSurname');
  }

  get secondSurname() {
    return this.cedulaForm.get('secondSurname');
  }

  get dateOfBirth() {
    return this.cedulaForm.get('dateOfBirth');
  }

  get curp() {
    return this.cedulaForm.get('curp');
  }

  get documentNumber() {
    return this.cedulaForm.get('documentNumber');

  }

  ngOnInit() {

    this.cedulaForm = this.fb.group({
      secondSurname: ['', [Validators.required]],
      firstSurname: ['', [Validators.required]],
      surname: ['', []],
      nationality: ['', []],
      birthplace: ['', []],
      gender: ['', []],
      expedition_date: ['', []],
      dateOfExpiry: ['', []],
      documentNumber: ['', []],
      curp: ['', []],
      registry_year: ['', []],
      claveElector: ['', []],
      crc_section: ['', []],
      dateOfBirth: ['', [Validators.required]],
      name: ['', [Validators.required]]
    });
  }

  nextPage() {

    console.log(this.cedulaForm.value);
    this.cedula = this.cedulaForm.value;
    this.storageService.saveToStorage('OCR', JSON.stringify(this.cedula)).then();

    const req = {
      firstName: this.cedula.name,
      middleName: this.cedula.firstSurname,
      lastName: this.cedula.secondSurname,
      sex: this.cedula.gender,
      birthDate: this.cedula.dateOfBirth
    };
    this.bidService.updatePerson(this.personId, req).subscribe(data => {
      this.updateOperation();
      this.router.navigateByUrl('validar-rfc');
    });

    this.router.navigateByUrl('validar-rfc');
  }

  updateOperation() {

    const reqOperation = {
      currentSecuenceId: '8',
      activityValue: 'ID_OK'
    };
    this.bidService.updateOperation(this.operationId, reqOperation).subscribe();
  }


  levenshtein(file) {

    switch (file) {

      case 'nombre':
        try {

          if (this.nombreD.length > 0) {
            const x = levenshtein(this.nombreD, this.cedulaForm.get('name').value.toUpperCase());
            if (x > 2) {
              this.cedulaForm.controls['name'].setErrors({'error': true});
            }
          }

        } catch (e) {

        }
        break;

      case 'paterno':
        try {

          if (this.paternoD.length > 0) {
            const x = levenshtein(this.paternoD, this.cedulaForm.get('firstSurname').value.toUpperCase());
            if (x > 2) {
              this.cedulaForm.controls['firstSurname'].setErrors({'error': true});
            }
          }

        } catch (e) {

        }
        break;

      case 'materno':
        try {

          if (this.maternoD.length > 0) {
            const x = levenshtein(this.maternoD, this.cedulaForm.get('secondSurname').value.toUpperCase());
            if (x > 2) {
              this.cedulaForm.controls['secondSurname'].setErrors({'error': true});
            }
          }
        } catch (e) {

        }
        break;

      case 'curp':
        try {

          if (this.curpD.length === 18) {
            const x = levenshtein(this.curpD, this.cedulaForm.get('curp').value.toUpperCase());
            if (x >= 8) {
              this.cedulaForm.controls['curp'].setErrors({'error': true});
            }
          }

        } catch (e) {

        }
        break;

      case 'documentNumber':
        try {

          const x = levenshtein(this.documentNumberF, this.cedulaForm.get('documentNumber').value);

          if (x >= 2) {
            this.cedulaForm.controls['documentNumber'].setErrors({'error': true});
          }
        } catch (e) {

        }
        break;

    }

  }

}
